// src/App.js
import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Navbar from './components/Navbar';
import Blog from './components/Blog';
import About from './components/About';
import BlogPage from './components/BlogPage';
import Loading from './components/Loading';
import './App.css';

const App = () => {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000); // Simulate loading delay
    return () => clearTimeout(timer);
  }, []);

  // Reset tab title when returning to the main page
  useEffect(() => {
    if (location.pathname === '/') {
      document.title = 'Iburtum | مدونة'; // Default title
    }
  }, [location]);

  return (
    <div className="app-container">
      {loading ? (
        <Loading />
      ) : (
        <>
          <Navbar />
          <AnimatePresence mode="wait">
            <Routes location={location} key={location.key}>
              <Route
                path="/"
                element={
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Blog />
                  </motion.div>
                }
              />
              <Route
                path="/about"
                element={
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <About />
                  </motion.div>
                }
              />
              <Route
                path="/blog/:id"
                element={
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <BlogPage />
                  </motion.div>
                }
              />
            </Routes>
          </AnimatePresence>
        </>
      )}
    </div>
  );
};

export default App;